import { Tags } from "../../Tags/shared/Tags.js";
import { useLocationGroups } from "../hooks/useLocationGroups.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationGroupTags.tsx
function LocationGroupTags({ locationGroupIds, ...tagsProps }) {
	const { data } = useLocationGroups({ idFilter: locationGroupIds }, { cacheStrategy: "cache-only" });
	if (data) return /* @__PURE__ */ jsx(Tags, {
		subtle: true,
		tags: data.locationGroups,
		...tagsProps
	});
	return null;
}
//#endregion
export { LocationGroupTags };

//# sourceMappingURL=LocationGroupTags.js.map